// Konsensüs oran sağlayıcıları canlı olduğunu bildirir, ancak maç saatini
// vermez. API-Football'dan gerçek dakika geldiyse onu kullanırız; aksi hâlde
// başlangıç saatinden temkinli bir tahmin üretiriz. Futbol dışındaki sporlarda
// bu değer oyun saati/periyot değil, etkinliğin başlamasından geçen süredir.

const asExactMinute = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const minute = Number(value);
  if (!Number.isFinite(minute) || minute < 0) return null;
  return Math.max(1, Math.floor(minute));
};

export const getLiveClock = (event = {}, now = Date.now()) => {
  const exactMinute = asExactMinute(event.elapsed ?? event.minute);
  if (exactMinute !== null) {
    return { label: `${exactMinute}'`, estimated: false };
  }

  const startedAt = Date.parse(event.start_time || event.date || '');
  const nowAt = now instanceof Date ? now.getTime() : Number(now);
  if (!Number.isFinite(startedAt) || !Number.isFinite(nowAt)) {
    return { label: 'CANLI', estimated: false };
  }

  const wallMinutes = Math.floor((nowAt - startedAt) / 60000);
  // Canlı uç en fazla son 24 saati tarar. Daha eski başlangıç zamanı veri
  // hatası/ertelenmiş etkinlik olabilir; böyle bir kaydı dakika diye sunmayız.
  if (wallMinutes < 0 || wallMinutes > 1440) {
    return { label: 'CANLI', estimated: false };
  }

  if ((event.sport || '').toUpperCase() !== 'SOCCER') {
    return {
      label: `${Math.max(1, wallMinutes)}'`,
      estimated: true,
    };
  }

  // Standart 15 dakikalık devre arasını maç dakikasına katmayız. Devre
  // aralığında kesin saniye bilinmediğinden 45+ gösterimi daha dürüsttür.
  if (wallMinutes > 45 && wallMinutes < 60) {
    return { label: "45+'", estimated: true };
  }
  if (wallMinutes > 105) {
    return { label: "90+'", estimated: true };
  }

  const minute = wallMinutes >= 60 ? wallMinutes - 15 : wallMinutes;
  return {
    label: `${Math.max(1, minute)}'`,
    estimated: true,
  };
};
